import { Trans, useTranslation } from 'react-i18next';
import CustomTitleBar from 'src/components/GuideMeTitleBar';
import Button from 'src/components/design-system/Button';

const BrowseCatalogsContent = () => {
  const { t } = useTranslation();

  return (
    <ul className="space-y-1 px-4 font-bold text-[13px]">
      <li className="list-disc font-semibold">{t('browseCatalogsGuide.filterBySearch')}</li>
      <li className="list-disc font-semibold">
        <Trans
          i18nKey="browseCatalogsGuide.browseCatalog"
          components={{
            browseCatalogButton: (
              <Button color="info" className="inline-block" readonly={true} size="md">
                {null}
              </Button>
            ),
          }}
        />
      </li>
      <li className="list-disc font-semibold">
        <Trans
          i18nKey="browseCatalogsGuide.supplierInfo"
          components={{
            supplierInfo: (
              <button
                type="button"
                className="pointer-events-none p-0 font-semibold leading-none text-info"
                tabIndex={-1}
              />
            ),
          }}
        />
      </li>
      <li className="list-disc font-semibold">
        <Trans
          i18nKey="browseCatalogsGuide.programInfo"
          components={{
            programInfo: (
              <button
                type="button"
                className="pointer-events-none p-0 font-semibold leading-none text-info"
                tabIndex={-1}
              />
            ),
          }}
        />
      </li>
    </ul>
  );
};

export const useGuideMeSteps = () => {
  const { t } = useTranslation();

  return [
    {
      content: <BrowseCatalogsContent />,
      title: (
        <CustomTitleBar
          title={t('browseCatalogsGuide.title')}
          className="font-bold text-xl text-red-600"
        />
      ),
    },
  ];
};

export default useGuideMeSteps;
